module.exports = __webpack_public_path__ + "images/emoji/pear.5d0f2730e95b8638b6ef.png";